import { useCallback, useEffect, useRef, useState } from 'react';

import _ from 'lodash';

import { RESIZE_THROTTLE_MS } from './constants';

const useContentWidth = () => {
  const [contentWidth, setContentWidth] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    const onResize = _.throttle(() => {
      if (!containerRef.current) {
        return;
      }

      setContentWidth(containerRef.current.clientWidth);
    }, RESIZE_THROTTLE_MS);

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
      onResize.cancel();
    };
  }, []);

  const setRef = useCallback(node => {
    if (node) {
      setContentWidth(node.clientWidth);
    }

    containerRef.current = node;
  }, []);

  return { containerRef, contentWidth, setContentWidth, setRef };
};

export default useContentWidth;
